module.exports = "https://d1tntvpcrzvon2.cloudfront.net/vwassets/new2/_next/static/images/pdp_postcardHover-417eb0549d2f4a595247d3458b914f12.jpg";